import { render, staticRenderFns } from "./ProblemPassageNext.vue?vue&type=template&id=18cf5257&scoped=true&lang=pug&"
import script from "./ProblemPassageNext.vue?vue&type=script&lang=ts&"
export * from "./ProblemPassageNext.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemPassageNext.vue?vue&type=style&index=0&id=18cf5257&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf5257",
  null
  
)

export default component.exports